import React,{useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AuthService from '../containers/auth/authService';
import { loginAction, logoutAction,setAzureMsal,setAzureUserAcc } from "../actions/index";
import { bindActionCreators } from "redux";

import * as constants from '../const';

import Idle from 'react-idle';

import { useLocation,useNavigate,useSearchParams} from 'react-router-dom';
   // logout when crossed session expiry time

  const authComponent = (ComposedComponent) => {   
    const authState = useSelector((state) => state.authState);
    const props = useSelector((state) => state);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();    
    
  //component will mount

  useEffect(() => {

    
    let pathName = location.pathname;
       // checking if user is authenticated and came to the login screen (using browser back)
       if (!authState.authenticated) { // is user not authenticated in and trying to access private modules
         if (pathName !== '/admin') {
          logoutAction()(dispatch);
           navigate('/', { replace: true });
         }
       }
       else if (pathName == "/" && authState.homePath) {
        
         navigate(authState.homePath);
       }
       else if (pathName == "/") {
        logoutAction()(dispatch);
       } else {
         try { // user authenticated 
           let profile = {
             authenticated: authState.authenticated,
             role: authState.role,
             id_token: authState.id_token,
             api_token: authState.api_token,
             name: authState.name,
             employeeID: authState.employeeID,
             impersonateUserId: authState.impersonateUserId,
             activeMenus: authState.activeMenus,
             isSystemAdmin: authState.isSystemAdmin,
             userId: authState.impersonateUserId > 0 ? authState.userId : authState.employeeID
           };

           loginAction('LoginSuccess', profile)(dispatch);
           var role = profile.role;
           var isImpLog = authState.impersonateUserId > 0;
           if (role == 'Admin' && localStorage.getItem("impersonateUserId") > 0) {
             
             navigate(constants.routes.defaultAdminRoute);
           }

           if ((role != 'Admin' && !isImpLog) && pathName != '/workdays' && pathName != '/userhoslogsworkdays' && pathName != '/series' && pathName != '/frareport') { // if the role is "Employee" and trying to access "Admin" Module
             alert("Sorry, you can not access screens");             
             navigate('/workdays', { replace: true });
           }
         }
         catch (err) { // any exception comes just logout
          logoutAction()(dispatch);
           navigate('/', { replace: true });
         }
       }
  }, []);

 
  return (
    
    <div className="fullHeight">
      <Idle timeout={constants.sessionExpiryTime}
        onChange={({ idle }) => {
          if (idle) {
            logoutOnSessionExpired(props);
          }
        } } />
      <ComposedComponent {...props} currentPathName={location.pathname} navigate={useNavigate()} />
    </div>
  );


  }

  function logoutOnSessionExpired(props) {
    if (props.authenticated) {
      localStorage.clear();
      logoutAction()(dispatch);
      const navigate = useNavigate();
      navigate('/', { replace: true });
    }
  }  

  export default authComponent;
    